var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"account__form-wrap"},[_c('YourInformation'),_c('YourEmail'),_c('YourPassword'),_c('AccountStatus')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }